.section {
	@apply yst-py-8 yst-space-y-4;
}

.actionIcon {
	@apply yst-w-4 yst-h-4;
}

.empty {
	@apply yst-text-slate-600;
}

.prefix {
	@apply yst-font-mono yst-text-sm yst-text-slate-600;
}

.scopeBadges {
	@apply yst-inline-flex yst-flex-wrap yst-gap-1;
}

.tableContainer {
	// The ui-library only sets `min-width: 100%` on the table, so with
	// `table-layout: auto` a narrow content set leaves the table narrower than
	// its wrapper — the ring/dividers then stop partway across, leaving a stray
	// vertical edge. Force full width so borders span edge to edge.
	table {
		@apply yst-w-full;
	}

	// Card mode only: the stacked layout doesn't need the full content width, so
	// cap it to read as a card. Gated inside the media query so ≥xl (table mode)
	// keeps the full available width.
	@media (max-width: 1279.98px) {
		max-width: 32rem;
	}
}

// Responsive table: the ui-library table is `table-layout:auto` + `min-width:100%`
// with no-wrap cells, so 7 columns have an intrinsic width (~1000px+) that
// exceeds the content area once the sidebar is present. Rather than wrap,
// truncate or scroll, we collapse it into stacked cards (one labelled field per
// line) below `xl` (1280px) and only render the real table on genuinely wide
// screens where it fits. Same mechanism as OrdersPage, wider breakpoint.
.tableHead {
	@apply yst-hidden xl:yst-table-header-group;
}

.tableBody {
	td::before {
		content: attr(data-label);
		@apply yst-font-bold yst-text-slate-500 xl:yst-hidden;
	}

	// The actions cell carries no data-label; hide its (empty) pseudo-label.
	td:last-of-type::before {
		@apply yst-hidden;
	}

	// Below xl the ui-library forces display:table-* via !important utility
	// classes (the preset sets important:true), so collapsing the table into
	// stacked rows requires !important on our display overrides.
	@media (max-width: 1279.98px) {
		display: block !important;

		tr {
			@apply yst-py-4;

			display: block !important;
		}

		td {
			// Stacked field: label above value, tight spacing (the library's
			// py-4 leaves huge gaps once stacked).
			@apply yst-items-start yst-gap-0.5 yst-px-0 yst-py-1.5;

			display: flex !important;
			flex-direction: column;
		}
	}
}

.modalBody {
	@apply yst-flex yst-flex-col yst-gap-4 yst-my-4;
}

.modalActions {
	@apply yst-flex yst-justify-end yst-gap-3;
}

.tokenRow {
	@apply yst-flex yst-items-stretch yst-gap-2;
}

.tokenValue {
	@apply yst-flex-1 yst-min-w-0 yst-font-mono yst-text-sm yst-bg-slate-100 yst-rounded yst-px-3 yst-py-2 yst-whitespace-nowrap yst-overflow-hidden yst-text-ellipsis;
}

.copyButton {
	@apply yst-shrink-0;
}

.warning {
	@apply yst-font-bold yst-m-0;
}

.scopeRow {
	@apply yst-flex yst-items-center yst-gap-1.5;
}

.scopeHelp {
	@apply yst-relative yst-inline-flex yst-items-center yst-cursor-help yst-rounded-full;

	.scopeTooltip {
		display: none;
	}

	&:hover,
	&:focus-within {
		.scopeTooltip {
			display: inline-block;
		}
	}

	&:focus-visible {
		@apply yst-outline-none yst-ring-2 yst-ring-primary-700;
	}
}

.scopeHelpIcon {
	@apply yst-w-4 yst-h-4 yst-text-slate-400;
}

.scopeTooltip {
	@apply yst-max-w-xs yst-whitespace-normal yst-text-left;
}

.scopesSummary {
	@apply yst-flex yst-flex-wrap yst-items-center yst-gap-2 yst-m-0;
}

.revokeIrreversible {
	@apply yst-font-bold yst-mt-2;
}
